export interface TopEvidence {
  // Demo-shaped citations carry the twin identity; real worker-written
  // citations (worker/routes/v1/v1.ts:3459) do NOT — they carry memory_id +
  // source_row_index instead. All twin fields are therefore optional.
  twin_id?: string
  respondent_label?: string
  segment?: string
  memory_id?: string
  source_row_index?: number
  quote: string
  source_text_is_untrusted: boolean
}

/**
 * Pure rendering decision for a single evidence citation. Exported for unit
 * testing and shared by every page that renders `top_evidence` (the JSX
 * evidence map is the only consumer, so this helper is the single source of
 * truth for the link-vs-text contract).
 *
 * Demo-shaped citation (twin_id present) → an Echo-Indigo Link to the twin.
 * Real-shaped citation (no twin_id) → a non-link text label, so we never emit
 * a dead `/twins/undefined` href or duplicate/undefined React keys.
 */
export function evidenceItemView(
  ev: TopEvidence,
  index: number,
  projectId: string | undefined,
): { key: string | number; kind: 'link' | 'text'; to?: string; label: string; segment?: string } {
  const pid = projectId ?? 'demo'
  if (ev.twin_id) {
    return {
      key: ev.twin_id,
      kind: 'link',
      to: `/app/projects/${pid}/twin-panel/twins/${ev.twin_id}`,
      label: ev.respondent_label ?? ev.twin_id,
      segment: ev.segment,
    }
  }
  const label = ev.source_row_index != null ? `Survey row ${ev.source_row_index + 1}` : 'Source quote'
  return {
    key: ev.memory_id ?? index,
    kind: 'text',
    label,
    segment: ev.segment,
  }
}
